
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import IconOeamtcClose from '@components/icons/icon-oeamtc-close.svg';
import IconCheck from '@components/icons/icon-check.svg';
import { Location } from 'vue-router';

@Component({
  name: 'SettingsFooter',
  components: {
    IconOeamtcClose,
    IconCheck
  }
})
export default class SettingsFooter extends Vue {
  @Prop({ default: false })
  private disabled: boolean;

  @Prop({ required: false })
  private closeTo: Location;

  @Prop({ required: false })
  private errorMessage: string;

  @Prop({ default: false })
  private shouldReplace: boolean;
}
